import { createCompassModalSwitcher } from "@circle-react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";

import { ReportPostModalComponent } from "./ReportPostModalComponent";
import { ReportPostModalUIKitComponent } from "./ReportPostModalUIKitComponent";

export const useReportPostModal = createCompassModalSwitcher(
  ReportPostModalComponent,
  ReportPostModalUIKitComponent,
);
